module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar d-flex flex-column h-100 position-relative"
  }, [_c('div', {
    staticStyle: {
      "height": "65px"
    }
  }, [_c('navigator', {
    attrs: {
      "calendarApi": _vm.calendarApi,
      "fullCalendarView": _vm.fullCalendarView
    },
    on: {
      "updateArrowDate": _vm.calculateSunTimes
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "calendar-content-p d-flex flexGrow1 position-relative"
  }, [_c('div', {
    staticClass: "flexGrow1"
  }, [_c('div', {
    ref: "calendarWidth",
    staticClass: "calendar-wrapper",
    class: {
      'hide-day-header': _vm.getCurrentView === 'agendaDay'
    },
    on: {
      "mousemove": _vm.positionCursorX
    }
  }, [_c('span', {
    staticClass: "config-gear"
  }, [_c('i', {
    staticClass: "fas fa-cog ml-2 pointer dark fs-large",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openSettings.apply(null, arguments)
      }
    }
  })]), _vm._v(" "), (_vm.isLoadingCalendarEvents) ? _c('div', {
    staticClass: "calendar-loading-overlay"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), _c('FullCalendar', {
    ref: "fullCalendar",
    attrs: {
      "options": _vm.calendarOptions
    }
  })], 1)]), _vm._v(" "), _c('events', {
    attrs: {
      "calendarApi": _vm.calendarApi
    },
    on: {
      "changeFilters": _vm.filtersChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "1rem"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-8e6efd2e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e6efd2e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Calendar.vue
// module id = 2744
// module chunks = 0